import log from "./log";
import auth from "./auth";
import title from "./title";
import hasPermission from "./hasPermission";
import history from "./history";

export default [auth, log, title, hasPermission, history];
